'use client';

import { useEffect } from 'react';

export default function IOSZoomFix() {
  useEffect(() => {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (!isIOS) return;

    const fixIOSZoom = () => {
      document.body.style.transform = 'none';
    };

    window.addEventListener('resize', fixIOSZoom);

    const handleFocusOut = () => {
      setTimeout(fixIOSZoom, 50);
    };

    document.addEventListener('focusout', handleFocusOut);

    return () => {
      window.removeEventListener('resize', fixIOSZoom);
      document.removeEventListener('focusout', handleFocusOut);
    };
  }, []);

  return null;
}